const pt = {
    10000001: 'SuperEx二周年庆',
    10000002: '签到领取丰厚奖励！',
    10000003: '根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高10,000USDT獎金池',
    10000004: 'SuperEx 兩週年',
    10000005: '合約慶典賽贏取20,000USDT',
    10000006: `交易量排名赛，解锁最高 <span style="color: #ffc72b;">10,000</span> USDT 奖金池`,
    10000007: '合約冠軍賽',
    10000008: '贏取20,000USDT獎池！',

    10000009: 'Selecionar',
    10000010: 'Oferta Total',
    10000011: 'Explorador',
    10000012: 'Retornar',
    10000013: 'Próximo',
    10000014: 'Anterior',
    10000015: 'Preencha as informações',
    10000016: 'Por favor, insira o nome do token',
    10000017: 'Por favor, insira o nome completo do token.',
    10000018: 'Entendi',
    10000019: 'Insira o nome da instância do par de negociação.',
    10000020: 'Por favor, forneça a oferta circulante do token.',
    10000021: 'Feito',
    10000022: 'Depois disso, você pode ver os dados estatísticos do par de negociação na página do Mercado Livre do site.',
    10000023: '{currency} listado na Exchange!',
    10000024: 'Ano',
    10000025: 'Mês',
    10000026: 'Dia',

    10001000: 'Alavancagem e Margem',
    10001001: 'Margem Inicial = Contagem de Posições * Valor Nominal / Nível de Alavancagem',
    10001002: 'Margem de Manutenção = Contagem de Posições * Valor Nominal * Taxa de Margem de Manutenção - Montante de Manutenção',
    10001003: 'Nível {tier}',
    10001004: 'Posição (Contagem)',
    10001005: 'Máxima Alavancagem',
    10001006: 'Taxa de Manutenção da Margem',
    10001007: 'Montante de Manutenção (USDT)',
    10001008: '* Última atualização das regras:',
    10001009: '* A alavancagem máxima de 150x em contratos futuros com margens em USDⓈ inclui:',
    10001010: '* Por favor, esteja ciente de que, em caso de flutuações extremas de preços ou desvios do índice de preços, a SuperEx tomará medidas adicionais de proteção, incluindo, mas não se limitando a: ',
    10001011: '1. Ajustar o valor máximo de alavancagem ',
    10001012: '2. Ajustar o limite de posição em cada nível ',
    10001013: '3. Ajustar a taxa de margem de manutenção em cada nível',
    10001014: 'Escolher contrato',
    10001015: '{symbol} perpétuo',
    10001016: 'O valor nocional da sua posição inclui tanto as posições longas quanto as curtas.',
    10001017: 'O máximo de alavancagem disponível depende do valor nocional da sua posição.',
    10001018: 'A margem de manutenção é calculada com base nas suas posições em diferentes faixas de valor nocional.',
    10001019: ' = Tamanho máximo da posição (contratos) no nível N-1 * valor nominal * (taxa de margem de manutenção no nível N - taxa de margem de manutenção no nível N-1) + quantidade de cálculo rápido da margem de manutenção no nível N-1',

    8000067: 'Estatísticas',
    8000068: 'Moeda Token',
    8000069: 'Cadeia principal ou Protocolo',
    8000070: 'Endereço do contrato ou Ticker',
    8000071: 'Nome da Instância',
    8000072: 'Tempo de Criação da Instância',
    8000073: 'Estado da Instância',
    8000074: 'Montante de Comissão (Acumulado)/U',
    8000075: 'Valor de comissão (última semana)/U',
    8000076: 'Valor da Transação (Semana Passada)/U',
    8000077: 'Número de Transações (Semana Passada)',
    8000078: 'Criar um par de negociação',
    8000079: 'Prorrogação',
    8000080: 'Listados',
    8000081: 'Em Breve Removido',
    8000082: 'Removido',
    8000083: 'Selecionar moeda',
    8000084: 'Notificação de listagem',
    8000085: 'Criação bem-sucedida',
    8000086: 'Listagem no Mercado Livre',
    8000087: 'No SuperEx, você pode facilmente e gratuitamente concluir listagens na bolsa e ter a oportunidade de receber até 80% de dividendos das taxas de negociação.',
    8000088: 'Como funciona?',
    8000089: 'Criar um novo par de negociação',
    8000090: 'Vou listar a moeda',
    8000091: 'Criar uma Instância de Par de Negociação',
    8000092: 'SuperEx Exchange',
    8000093: 'Por que nos escolher?',
    8000094: 'Escolhas Diversas',
    8000095: 'Suporta múltiplas cadeias, incluindo as cadeias BSC, ETH e SOL.',
    8000096: 'Listagem imediata sem verificação manual, como um processo descentralizado, e aproveite a conveniência da negociação em livro de ordens.',
    8000097: 'API Suportado',
    8000098: 'Você pode usar a interface da API para realizar criação de mercado ou negociação, tornando suas operações mais eficientes e automatizadas.',
    8000099: 'Exposição e Tráfego',
    8000100: 'Ao listar no Free Market, aproveite o grande tráfego de usuários da SuperEx e ganhe mais atenção.',
    8000101: 'Quer você seja um iniciante ou um trader experiente, nosso Mercado Livre trará novas experiências e oportunidades de investimento. Crie imediatamente seus próprios pares de negociação, promova suas moedas favoritas e aproveite a renda de comissão das taxas de negociação!',
    8000102: 'Seu total de ativos deve exceder {resultData}U para você ser elegível para criar um par de negociação.',
    8000103: 'Listando Seu Token Favorito',
    8000104: 'Você pode escolher sua criptomoeda favorita e emparelhá-la com USDT para criar um par de negociação exclusivo.',
    8000105: 'Recebendo comissão de taxas',
    8000106: 'Quando o volume de negociação de uma Instância de Par de Negociação que você criou atinge um determinado limite, uma parte das taxas de transação será retornada a você como comissões. Isso permite que você, como criador da Instância de Par de Negociação, também participe dos lucros das negociações.',
    8000107: 'Você agora é um usuário restrito e, temporariamente, não pode criar novos pares de negociação. Tente novamente amanhã.',
    8000108: 'Por favor, selecione um idioma',
    8000109: 'Livro Branco',
    8000110: 'O token foi banido de ser listado!',
    8000111: 'Este token já está listado no Mercado Principal da SuperEx e você não pode criar outro par de negociação!',
    8000112: 'Por favor, insira um endereço de contrato / Ticker válido!',
    8000113: 'Seu saldo de ET na Main Market é insuficiente. Para criar uma nova instância de par de negociação, você precisa pagar uma taxa de gerenciamento de  {num} ET Por favor, recarregue e tente novamente.',
    8000114: 'Você fez muitas entradas incorretas durante o processo de criação de um novo par de negociação hoje. Portanto, você não poderá enviar mais solicitações hoje. Tente novamente amanhã.',
    8000115: 'O token já existe, agora iremos criar uma nova instância do par de negociação para você!',
    8000116: 'Por favor, confirme as informações a seguir:',
    8000117: 'Comprimento decimal da quantidade de token',
    8000118: 'Como listar uma moeda livremente',
    8000119: 'Nome completo do token',
    8000120: 'Comprimento decimal do preço do token',
    8000121: 'SUPEREX Listagem de Moedas: <em class="normal" style="color: #0CAA6D;">0 Taxa de Listagem! </em><em class="normal" style="color: #1D90F5;">0 Custos de Comunicação! </em>Complete a listagem em 1 minuto e desfrute de até <em class="normal" style="color: #F65D62;">80% de compartilhamento de lucros</em>.',
    8000122: 'Introdução ao token em inglês',
    8000123: 'As informações a seguir são obrigatórias:',
    8000124: 'O nome da instância que você inseriu já existe. Por favor, insira um diferente.',
    8000125: 'As informações a seguir são opcionais:',
    8000126: 'Por favor, escolha a cadeia principal ou protocolo e a taxa de gestão correspondente.',
    8000127: 'Passo 1: Copie e cole o endereço do contrato da nova moeda',
    8000128: 'Por favor, insira o endereço do contrato / Ticker/ID.',
    8000129: 'Confirmar',
    8000130: 'Sua instância do par de negociação {currency} foi criada com sucesso！',
    8000131: 'Passo 2: Se esta moeda está sendo listada em nossa exchange pela primeira vez, você precisa completar alguns detalhes básicos, como a introdução da moeda e o envio da imagem do logotipo.',
    8000132: 'Mercados do Protocolo BTC',
    8000133: 'Passo 3: Você só precisa nomear a instância deste par de negociação que criou. Depois disso, o processo de listagem está completo e a moeda pode ser negociada publicamente.',
    8000134: 'Adicionar Tokens',
    8000135: 'Por favor, insira o fornecimento total.',
    8000136: 'Passo 4: Assim que o volume de negociação semanal da sua instância atingir um limite, você receberá uma parte das taxas de negociação da instância.',
    8000137: 'Se você escolher 8, isso significa que o valor do preço da sua criptomoeda é exibido com precisão até 0,00000001. Por exemplo, o preço do BTC é exibido como $72186.12345678. Para a maioria das moedas MEME, recomendamos escolher 8.',
    8000138: 'Por favor, insira',
    8000139: 'Vou começar a listar a moeda.',
    8000140: 'Por favor, insira uma breve descrição do token em inglês.',
    8000141: `Você pode entender facilmente 'instância' como múltiplas versões do mesmo par de negociação, sendo uma dessas versões a instância que você criou. Outros usuários distinguem essas versões pelo nome da instância. Desde que os usuários escolham sua instância para negociar, você tem a oportunidade de receber os correspondentes dividendos de taxa.`,
    8000142: 'O formato do e-mail está incorreto.',
    8000143: 'Por favor, insira o endereço da consulta da blockchain.',
    8000144: 'Fornecimento Circulante',
    8000145: 'O suprimento circulante é limitado a um número inteiro positivo de 1 a 20 dígitos.',
    8000146: 'Ícone do Token',
    8000147: 'Suporta formato PNG ou JPG, limite de tamanho de arquivo de 500 KB, e você pode fazer até 10 uploads por dia.',
    8000148: 'Data de Emissão',
    8000149: 'Por favor, selecione a data de emissão.',
    8000150: 'Por favor, insira o link do white paper.',
    8000151: 'Site Oficial',
    8000152: 'Por favor, forneça o link do site oficial.',
    8000153: 'Listagem Livre de Ativos',
    8000154: 'Colocando seu token na exchange',
    8000155: 'O limite de entrada para o nome do token é de 9 caracteres, suportando apenas números, letras em inglês e símbolos em inglês.',
    8000156: 'O limite de entrada para o nome completo do token é de 50 caracteres, e apenas números, espaços, letras em inglês e símbolos em inglês são suportados.',
    8000157: 'A quantidade total deve ser um número inteiro positivo de 1 a 20 dígitos.',
    8000158: 'Os caracteres iniciais ou finais não podem ser espaços, e não podem existir espaços consecutivos. O símbolo "/" e emojis não são suportados.',
    8000159: '1. O emissor é responsável pela autenticidade das informações, e a plataforma se reserva o direito de deslistar tokens ou pares de negociação a qualquer momento e ajustar o conteúdo das informações a qualquer momento.',
    8000160: '2. O emissor deve realizar uma pesquisa abrangente sobre o token listado e ser responsável por sua razoabilidade, conformidade e legalidade. Se a plataforma detectar comportamentos ou conteúdos maliciosos, prejudiciais ou específicos no contrato inteligente do token, o token será retirado diretamente e a plataforma representará os usuários em reivindicações contra o emissor.',
    8000161: '3. Se o emissor ou qualquer outra pessoa desejar fazer ajustes nas informações do token posteriormente, deve entrar em contato com nosso atendimento ao cliente.',
    8000162: '4. Para proteger os interesses dos usuários e eliminar tokens de baixa qualidade, se o par de negociação criado pelo emissor não atender aos requisitos de volume de negociação da nossa plataforma, o emissor será notificado sobre a listagem removida aproximadamente uma semana depois. Toda segunda-feira, a plataforma enviará notificações de remoção por e-mail e notificações no aplicativo para os casos não conformes. Os emissores terão a oportunidade de solicitar a prorrogação da listagem dentro de 5 dias. Se a solicitação for bem-sucedida, serão concedidas mais 4 semanas de tempo de observação; caso contrário, os casos serão removidos.',
    8000163: '5. Se a instância do par de negociação criada pelo emissor do token atender ao limite de volume de negociação para dividendos da plataforma, receberá os dividendos correspondentes às taxas.',
    8000164: 'Você está disposto a fornecer uma certa quantidade de tokens para atividades operacionais e marketing para expandir a influência da moeda?',
    8000165: '6. O emissor pode contatar o suporte ao cliente para solicitar a qualificação de Market Maker.',
    8000166: 'Criar',
    8000167: 'Você está prestes a criar uma instância do par de negociação{currency}e deduzir{upFee}ETda sua conta do Mercado Principal.',
    8000168: 'Não',
    8000169: 'Sim',
    8000170: 'Por favor, insira seu endereço de e-mail para que nossa equipe de operações de marketing possa entrar em contato com você.',
    8000171: 'Você tem um referenciador ou contato?',
    8000172: 'Insira nome ou contato do responsável',
    8000173: 'Ao marcar esta caixa, você reconhece todos os riscos envolvidos e concorda com nossos <a id="service_href" class="pointer" style="color: #D9A31A" target="_self">《Termos e Condições》</a>',
    8000174: 'Ganhos com listagem',
    8000175: 'O direito de listar em uma bolsa',
    8000176: 'O token não é suportado para listagem no momento!',
    8000177: 'Preencha as informações',
    8000178: 'Vá Compartilhar',
    8000179: 'listado na Exchange!!',
    8000180: 'SuperEx Mercado Livre, um mundo cripto dos usuários, pelos usuários, para os usuários.',
    8000181: 'Criei um par de negociação {symbol}，na SuperEx! Rumo à Lua!',
    8000182: 'O valor do dividendo para cada transação é atualizado na segunda-feira, mas pode haver um atraso de até 3 dias úteis durante o processo de distribuição real. Você pode verificar os registros relevantes em "Histórico da Carteira" - "Outros" - "Mercado Principal" através do tipo "Enviar Recompensas".',
    8000183: 'Conta do Twitter',
    8000184: 'Conta do Telegram',
    8000185: 'Conta do Discord',
    8000186: 'Insira um link do Twitter válido!',
    8000187: 'Insira um link válido do Telegram!',
    8000188: 'Insira um link válido do Discord!',
    8000189: 'Por favor, insira o link do Twitter',
    8000190: 'Por favor, insira o link do Telegram',
    8000191: 'Por favor, insira o link do Discord.',
    8000192: 'Desculpe, o conteúdo ou as configurações de permissão do contrato inteligente para esta moeda apresentam altos riscos de segurança. Tente usar outra moeda.',
    8000193: 'Desculpe, o conteúdo do contrato inteligente para esta moeda pode ter riscos potenciais. No momento, não pode ser listado. Por favor, tente usar outra moeda.',
    8000194: 'Nota:',
    8000195: 'Você precisa concluir o depósito para este token antes de poder fazer uma ordem de venda.',
    8000196: 'Você precisa transferir USDT para a Conta do Mercado Livre antes de fazer uma ordem de compra.',
    8000197: 'Você precisa conectar a API antes de poder realizar a negociação de market-making.',
    8000198: 'Falar com o Suporte Técnico',
    8000199: 'Por favor, insira um número inteiro entre 2 e 9',

    8100013: 'Canal de Verificação Oficial',
    8100014: 'Por favor, insira as informações de verificação',
    8100015: 'Você pode verificar o seguinte conteúdo',
    8100016: 'Somente e-mails oficiais do SUPEREX.COM são permitidos',
    8100017: 'Verificação de Identidade Oficial BD',
    8100018: 'Exemplo: conta oficial do Telegram/X(Twitter)',
    8100019: 'Verificação de Canal de Listagem',
    8100020: 'Se precisar assinar um contrato ou fazer um pagamento, confirme com o BD oficial.',
    8100021: 'Obrigado pelo seu interesse no<a href="/" style="color: #FFC72B" class="under-line pointer">SUPEREX.COM</a>, faremos o nosso melhor para proteger os direitos e interesses de todos.',
    8100022: 'Canal Não Oficial SuperEx',
    8100023: 'Canal Oficial SuperEx',
    8100024: 'O <em class="normal activeColor" style="word-break: break-word">{keyWord}</em>que você digitou não é um canal oficial da SuperEx. Por favor, garanta a segurança dos seus ativos e proteja suas informações pessoais.',
    8100025: 'O endereço<em class="normal activeColor" style="word-break: break-word">{keyWord}</em>em sua consulta é a {note}',
    8100026: 'Dicas de Segurança',
    8100027: '· Não interaja com contas não verificadas.',
    8100028: '· Não revele suas frases mnemônicas da carteira, e-mail registrado na SuperEx, número de telefone e/ou senha a ninguém.',
    8100029: '· Se precisar de mais assistência, entre em contato com o suporte ao cliente em support@superex.com.',
    8100030: 'Recebido um grande presente de {userName}!',
    8100031: 'Abrir presente',
    8100032: 'Falta apenas um último passo!',
    8100033: 'Baixe SuperEx agora e receba um presente de amigo!',
    8100034: 'Desistir do presente',
}
export default pt


// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/pt.js